
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { DropdownModule } from '../dropdown';

import { SelectComponent } from './select.component';
import { ButtonModule } from '../button';

@NgModule({
    declarations: [
        SelectComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        ButtonModule,
    ],
    exports: [
        SelectComponent,
    ]
})
export class SelectModule {
    public static forRoot() {
        return {
            ngModule: SelectModule,
            providers: []
        };
    }
}
